import { ReactElement, ReactNode, useEffect, useRef } from "react";
import { toggleModalState } from "../../../ReduxTool/Slice/CommonReducers/CommonReducers";
import { IconClose } from "../../../assests/icons/ModalIcons";
import { useAppDispatch, useAppSelector } from "../../../ReduxTool/store/hooks";
import { NewModalProp } from "./NewModalType";
import { toogleTooltip } from "../../../ReduxTool/Slice/Map/MapReducer";
import { Button } from "../../Button";
import { BackBoxIcon, TrendingUpIcon } from "../../../assests/icons/Icons";
import { IconInfo1 } from "../../../assests/icons/DrawerIcons";

export const NewModal = ({hidPrimaryBtn = false, capitalizeTitle = true,...props}: NewModalProp) => {
  const dispatch = useAppDispatch();
  const user = useAppSelector((state) => state.auth.user);
  // We'll use this ref for the backdrop
  const backdropRef = useRef<HTMLDivElement | null>(null);

  const closeModal = () => {
    dispatch(toogleTooltip({ dipy: 0, istooltip: "", msg: "" }));
    props.setIsCLose(false);
  };

  const openModal = () => { dispatch(toggleModalState(false)); };
  const { title, btnTxt, secondaryBtnTxt,tooltipContent,tooltipId } = useAppSelector((state) => state.commonReducers.modal);

  // Handle the click on the backdrop
  const handleBackdropClick = (event: React.MouseEvent) => {
    // Check if the click occurred directly on the backdrop element itself
    if (props.outerClickClose && backdropRef.current && event.target === backdropRef.current) {
      closeModal();
    }
  };

  return (
    <>
      <div className="modal-backdrop1" ref={backdropRef} onClick={handleBackdropClick} data-modal-name={props.datamodalid}>
        <div className={`main-modal2 ${props.modalSize + "-modal"} flex flex-col overflow-hidden max-h-full modalid-${props.datamodalid} `}>
          <div className="modal-header1">
            <div className={`heading-md-semibold flex-1 text-black ${capitalizeTitle ? "capitalize" : ""} ${
              // title === "Trial Period Expired" ? "text-[#FCA5A5]" : "text-black"
              ""}`} >
              <div className={`heading-md-semibold flex-1 flex items-center text-black ${capitalizeTitle ? "capitalize" : ""}`} >
             {props.title  ? props.title : title === "Congratulation" ? `Congratulation ${user.fname} 😊` : title} {(tooltipContent || tooltipId) && ( <span className="cursor-pointer flex-end ml-1" data-tooltip-id={`${tooltipId}Tooltip`}><IconInfo1 /></span>)} {/* Header tooltip */}
           </div>
          </div>
           {!props.isBack &&  <button onClick={closeModal}>  <IconClose />  </button>}
          </div>
          <div className={`modal-body2  custom-scrollbar-css ${props.scrollhide && "scrollbar-hide"} !min-h-[${props.minHeight}]`}
            style={{ overflow: props.overflow === undefined ? "scroll" : props.overflow + "" ,minHeight: props.minHeight ?? "", height: props.height ?? "", maxHeight: props.maxheight ?? "54vh", }} >
            {props.children}
          </div>
          {props?.isFooterRequired !== false && (
            <div className="modal-footer1">
              {secondaryBtnTxt && (
               <span className={`${props.isLoading && "cursor-not-allowed"}`}> <button disabled={props.isLoading} className={`btn btn-md-outlineprimary flex gap-2`} type="button"
                onClick={() => props.isBack ? closeModal() : props.onSecondaryClick ? props.onSecondaryClick() : props.onClick(secondaryBtnTxt)} >
                {props.outlinelefticon} {secondaryBtnTxt} {props.outlinerighticon}
              </button></span>
              )}
               {btnTxt && !props.modelbtn && !hidPrimaryBtn && ( <Button disabled={props.primaryBtnDisabled}   className={`${btnTxt === "" ? "hidden" : ""} btn btn-md-primary flex gap-2`} type="button" isLoading={props.isLoading ?? false} onClick={() => props.isAbleCLick && props.onClick(title)} >
                  <span className="flex gap-2">   {props.primarylefticon } {btnTxt} </span>
                </Button>)}

               {props.modelbtn && ( <Button className={`btn btn-md-primary ${props.primaryBtnWFull ? "w-full" : ""}`} disabled={props.isLoading} type="button" isLoading={props.isLoading ?? false} onClick={() => props.isAbleCLick && props.onClick(title)} ><span className="flex gap-2">   {props.primarylefticon } {props.modelbtn} {props.primaryrighticon} </span></Button>
                // <button
                //   className={`${btnTxt === "" ? "hidden" : ""} btn btn-sm-primary`}
                //   type="button"
                //   onClick={() => props.isAbleCLick && props.onClick(title)}
                // >
                //   {btnTxt}
                // </button>
              )}
            </div>
          )}
        </div>
      </div>
    </>
  );
};